import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RequestStatus } from '@/contracts';

export type UserState = {
  avatars: Record<string, { status: RequestStatus, source: string | null }>,
};

const initialState: UserState = {
  avatars: {},
};

export default createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: (state: UserState) => {
      state.avatars = {};
    },
    avatarBusy: (state: UserState, { payload }: PayloadAction<string>) => {
      if (state.avatars[payload]?.status !== RequestStatus.BUSY) {
        state.avatars = {
          ...state.avatars,
          [payload]: {
            status: RequestStatus.BUSY,
            source: null,
          }
        };
      }
    },
    avatarIdle: (
      state: UserState,
      { payload }: PayloadAction<{ userId: string, source: string | null }>
    ) => {
      state.avatars = {
        ...state.avatars,
        [payload.userId]: {
          status: RequestStatus.IDLE,
          source: payload.source,
        }
      };
    },
    avatarError: (state: UserState, { payload }: PayloadAction<string>) => {
      state.avatars = {
        ...state.avatars,
        [payload]: {
          status: RequestStatus.ERROR,
          source: null,
        }
      };
    },
  }
});
